// Transforma a lista flat de FinanceCategory (categoria-mãe + subcategorias, 2 níveis) em
// opções de Select — subcategoria aparece como "Mãe > Sub" pra ficar claro no dropdown qual
// categoria ela pertence. Usado por FormFinanceEntry/FormFinanceRecurring (escolher categoria)
// e Categories.js (montar a árvore pra exibição).
function buildCategoryOptions(categories) {
    const parents = categories.filter((c) => !c.parent)
    const options = []

    parents.forEach((parent) => {
        options.push({ value: parent._id, label: parent.name })
        categories
            .filter((c) => c.parent === parent._id || c.parent?._id === parent._id)
            .forEach((sub) => {
                options.push({ value: sub._id, label: `${parent.name} > ${sub.name}` })
            })
    })

    return options
}

export default buildCategoryOptions
